import React from "react";
import { cssTransition, toast } from "react-toastify/esm/react-toastify";
import { FormattedMessage } from "react-intl";
// import formatNotificationValues from "@ignitesales/neuro-application/src/validation/formatNotificationValues";

const notification = (message = "", toastId = 1, config) => {
  toast.dismiss(toastId);

  const transition = cssTransition({
    enter: "fadeIn",
    exit: "fadeOut",
    duration: [500, 0],
    appendPosition: false,
  });

  toast(message, {
    toastId,
    transition,
    className: "ignite-notification",
    draggable: false,
    autoClose: true,
    closeButton: true,
    ...config,
  });
};

export const notifyValidationErrors = (validationErrors = []) => {
  const toastId = "validationErrors";
  const questionErrors = validationErrors.map((error) => {
    return (
      <div className="notificationMessages__message" key={error.key}>
        {error.fieldType === "question" ? (
          <>
            <i className="fa fa-exclamation-circle" />{" "}
            <FormattedMessage id={error.key} tagName="span" />:{" "}
          </>
        ) : null}
        {Object.keys(error.errors).map((type) => {
          let values = error.errors[type];
          const validationType =
            type === "between" && values.length > 1 && values[0] === values[1]
              ? "equal"
              : type;
          // values = error.questionType ? formatNotificationValues(error.questionType, values) : values;
          return (
            <FormattedMessage
              key={`error.${error.fieldType}.${validationType}`}
              id={`error.${error.fieldType}.${validationType}`}
              values={{ ...values }}
            />
          );
        })}
      </div>
    );
  });

  const render = <div className="notificationMessages">{questionErrors}</div>;

  notification(render, toastId, {
    type: toast.TYPE.ERROR,
  });
};

export const notifySuccess = (messageId) => {
  const render = (
    <div className="notificationMessages">
      <div className="notificationMessages__title">
        <i className="fa fa-check" />
        <FormattedMessage id={`${messageId}.success.title`} />
      </div>
      <FormattedMessage id={`${messageId}.success.message`} />
    </div>
  );

  notification(render, messageId, {
    type: toast.TYPE.SUCCESS,
  });
};

export const clearNotifications = () => {
  toast.dismiss();
};

export default notification;
